// Special folder semantics:
export const STRANGERS = 'strangers';
export const YESTERDAYS_INBOX = 'yesterdays_inbox';
// Move-sender folder semantics:
export const OTHER = 'other';
export const NOISE = 'noise';

export const MOVE_SENDER = [
    OTHER,
    NOISE,
    'noise_commercial',
    'noise_generated',
    'noise_distribution_list',
    'noise_receipts',
    'noise_testing',
    'not_urgent',
    'not_urgent_travel',
    'reading',
];

const OPTION_OTHER = { value: OTHER, label: 'Other' };
const OPTION_NOISE = { value: NOISE, label: 'Noise' };
const OPTION_NOISE_COMMERCIAL = { value: 'noise_commercial', label: 'Noise - Commercial' };
const OPTION_NOISE_GENERATED = { value: 'noise_generated', label: 'Noise - Computer Generated' };
const OPTION_NOISE_DISTRIBUTION_LIST = { value: 'noise_distribution_list', label: 'Noise - Distribution List' };
const OPTION_NOISE_RECEIPTS = { value: 'noise_receipts', label: 'Noise - Receipts' };
const OPTION_NOISE_TESTING = { value: 'noise_testing', label: 'Noise - Testing' };
const OPTION_NOT_URGENT = { value: 'not_urgent', label: 'Not Urgent' };
const OPTION_NOT_URGENT_TRAVEL = { value: 'not_urgent_travel', label: 'Not Urgent - Travel' };
const OPTION_READING = { value: 'reading', label: 'Reading' };
const OPTION_STRANGERS = { value: STRANGERS, label: 'Outsiders' };
const OPTION_YESTERDAYS_INBOX = { value: YESTERDAYS_INBOX, label: 'Custom Inbox' };

export const FOLDER_CONTENTS_OPTIONS = [
    OPTION_READING,
    OPTION_NOT_URGENT,
    OPTION_NOT_URGENT_TRAVEL,
    OPTION_NOISE,
    OPTION_NOISE_COMMERCIAL,
    OPTION_NOISE_GENERATED,
    OPTION_NOISE_DISTRIBUTION_LIST,
    OPTION_NOISE_TESTING,
    OPTION_NOISE_RECEIPTS,
    OPTION_OTHER,
    OPTION_STRANGERS,
    OPTION_YESTERDAYS_INBOX,
];

export const ARCHIVAL_MODE_OPTIONS = [
    { value: 'off', label: 'Archival disabled' },
    { value: 'slow', label: 'Use the slow archival period' },
    { value: 'fast', label: 'Use the fast archival period' },
    { value: 'custom', label: 'Use a custom archival period' },
];
